import axios from '@src/utils/axios'

const module = 'brand'
const axiosInstance = axios(false);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, {params:data}),
  'create': (ctx, data) => axiosInstance.post(`/${module}`, data),
  'update': (ctx, data) => {
    return axiosInstance.put(`/${module}/` + data.id, data)
  },
  'find': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/` + data.id)
  },
  'all': () => axiosInstance.get(`/${module}/all`),
  'uploadLogo': (ctx, data) => axiosInstance.post(`/${module}/upload_logo`, data),
}